<template>
    <div class="text-center">
        <h1 style="margin-bottom: 100px">DGHS Dashboard</h1>
        <b-form class="form-signin">

            <img class="mb-4" src="https://www.erkoware.de/assets/img/logo.png" alt="" width="200" height="60">
            <h2 class="h3 mb-3 font-weight-normal">Bitte einloggen</h2>
            <b-form-group
                id="input-group-1"
                label="Email Adresse:"
                label-for="input-1"
            >
                <b-form-input
                    id="input-1"
                    v-model="username"
                    type="email"
                    required
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="input-group-2"
                label="Passwort:"
                label-for="input-2"
            >
                <b-form-input
                    id="input-2"
                    v-model="password"
                    type="password"
                    required
                ></b-form-input>
            </b-form-group>

            <p style="font-size: 22px; color: #f29814" v-if="statusText"> {{ statusText }} </p>

            <b-button @click="login" variant="primary">Login</b-button>
            <p class="mt-3 mb-3 text-muted">&copy; 2020 erkoware solutions GbR</p>
        </b-form>

    </div>
</template>

<script>

  export default {
    name: 'Login',
    mounted() {
    },
    methods: {
      login: function() {
        let vThis = this;

        this.$api.post('oauth/token', {
          username: this.username,
          password: this.password,
          client_id: 'dghs-backend',
          grant_type: 'password',
        })
          .catch(function () {
            // vThis.status = 'FAILED';
            vThis.statusText = 'Login Fehler!';
          })
          .then(function(response) {
              localStorage.setItem('user', response.data.access_token)
              vThis.$router.replace({ name: 'Home' })
          })
      }
    },
    data() {
      return {
        username: '',
        password: '',
        // status: '',
        statusText: '',
          time: null
      }
    }
  }

</script>

<style scoped>

  .ion-grid {
    width: 75%;
  }

  /*#grad {*/
  /*  !*background-image: linear-gradient(to bottom right, #4160a1, #96c5ef);*!*/
  /*  background-color: #166890;*/
  /*  height: 1000px;*/
  /*}*/

  ion-content{

    --ion-background-color:#f0f8ea;
    --ion-color: #424b54;
  }

  /*#toolbar {*/
  /*  padding: 5px;*/
  /*}*/

  #thumbnail {
    width: 150px;
    height: auto;
    padding: 5px;
  }

  #memberNumber {
    background-color: #f8f9fa;
    margin-top: 5px;
    color: #424b54;
    border: solid #66b588;
  }

  #zipcode {
    background-color: #f8f9fa;
    margin: 5px 0px 10px;
    color: #424b54;
    border: solid #66b588;
  }

  #login-button {
    font-size: 22px;
    /*background-image: linear-gradient(to right, #000428 0%, #004e92 51%, #000428 100%);*/
    /*background-position: right center*/
    --background: #66b588;
    --background-activated: #9ce1bd;
  }

  .custom-font {
    font-size: 22px;
    color: #424b54;
  }

  .ios ion-input {
    --padding-start: 8px;
  }
  .form-signin {
      width: 100%;
      max-width: 330px;
      padding: 15px;
      margin: auto;
  }


</style>
